/**
 * @docsCategory preference/lang
 * @docsPage types-type
 * @docsWeight 2
 */
type ValueOf<T> = T[keyof T];

/**
 * @description
 * An object that maps JavaScript types to their corresponding string representations.
 *
 * @docsCategory preference/lang
 * @docsPage types-type
 * @docsWeight 1
 */
const TYPES = {
  boolean: 'boolean',
  undefined: 'undefined',
  number: 'number',
  string: 'string',
  '[object Object]': 'object',
  '[object Function]': 'function',
  '[object RegExp]': 'regexp',
  '[object Array]': 'array',
  '[object Date]': 'date',
  '[object Error]': 'error',
  '[object Blob]': 'blob',
  '[object File]': 'file',
  '[object DOMException]': 'domError',
  '[object ArrayBuffer]': 'arrayBuffer',
} as const;

/**
 * @description
 * Returns the type of the given value.
 *
 * @param value - The value to determine the type of.
 * @returns The type of the value.
 *
 * @docsCategory preference/lang
 * @docsPage types-type
 * @docsWeight 3
 */
export function type(value): ValueOf<typeof TYPES> {
  return (
    TYPES[typeof value] ||
    TYPES[Object.prototype.toString.call(value)] ||
    (value ? 'object' : 'null')
  );
}
